export default __webpack_public_path__ + "static/media/logo-sm-dark.68c37f7b.svg";